import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useCallback, useState } from 'react';
import { Input } from '@chegg-ui/input';
import { PasswordInputElement, PasswordVisibilityButton } from '../styles';
import { PSWD_INPUT_STATE } from './PasswordInput.types';
var states = _defineProperty(_defineProperty({}, PSWD_INPUT_STATE.SHOW, {
  text: 'Show',
  type: 'password'
}), PSWD_INPUT_STATE.HIDE, {
  text: 'Hide',
  type: 'number'
});
var PasswordInput = function PasswordInput(props) {
  var hideButton = props.hideButton,
    fullHeight = props.fullHeight;
  var _useState = useState(hideButton ? PSWD_INPUT_STATE.HIDE : PSWD_INPUT_STATE.SHOW),
    _useState2 = _slicedToArray(_useState, 2),
    inputState = _useState2[0],
    setInputState = _useState2[1];
  var inputParams = states[inputState];
  var getPasswordInputState = useCallback(function () {
    if (inputState === PSWD_INPUT_STATE.SHOW) setInputState(PSWD_INPUT_STATE.HIDE);else setInputState(PSWD_INPUT_STATE.SHOW);
  }, [inputState, setInputState]);
  return /*#__PURE__*/React.createElement(PasswordInputElement, {
    "data-test": "validate_code_input",
    fullHeight: fullHeight
  }, /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    type: inputParams.type,
    "data-test": "password_text_input_element"
  })), !hideButton && /*#__PURE__*/React.createElement(PasswordVisibilityButton, {
    "data-test": "password_visibility_button",
    onClick: getPasswordInputState
  }, inputParams.text));
};
export { PasswordInput };